export const src = `
## Features
---

### Project

- Get project info, such as project ID, identifier and secret(for subgraph deployment)
- Invite project collaborators by Github ID/username
- Create project
- Change project name
- Delete project

### RPC Endpoint

- Generate Cronos mainnet/testnet RPC API
- Set RPC allow origins

### Subgraph

- Get subgraph info, such as GraphQL query URL, deploy URL, subgraph.yaml, logs and subgraph status
- Query subgraph with GraphQL playground
- Show subgraph deployment steps
- Create subgraph
- Delete subgraph


## Create your first subgraph
---

### Step 1: Create project
>Create your first project on the project list page (first item on the left navigation bar). You will need to
enter the project name and the project identifier.\\
**Note: project identifier is the subgraph URL prefix
(e.g. your-project-identifier/your-subgraph-identifier)**

### Step 2: Create subgraph
Create the subgraph in your new project. You will need to
enter the subgraph name and the subgraph identifier.\\
**Note: subgraph identifier is the subgraph URL pathname
(e.g. your-project-identifier/your-subgraph-identifier)**

You can start with the subgraph example [here](https://github.com/graphprotocol/example-subgraph.git). Run **yarn install** and **yarn codegen** to install dependencies and generate files for the deployment.


### Step 3: Config your subgraph.yml and package.json
In subgraph.yml:
- Set **apiVersion** to **0.0.4**.
- The **network** needs to be either **cronos** or **cronos-testnet**.
- Please specify the **startBlock** to the block in which the contract was created or "1" for the genesis block..
[Learn more](https://thegraph.com/docs/en/developer/create-subgraph-hosted/#the-subgraph-manifest)

Make sure the package.json library version same as below:
- "@graphprotocol/graph-cli": "^0.21.0"
- "@graphprotocol/graph-ts": "^0.20.0"

### Step 4: Deploy subgraph to the network
Now, you need to run graph command to deploy your subgraph to the network. For more deployment details, you can go to the subgraph detail page.

### Step 5: Start building your Dapp!
You can start building your dapp using the query url and test it at the **Playground** on subgraph detail page.
`;
